import React from "react";
import { Link } from "gatsby";
import "../../styles/buttons.css";

export default function orderButton() {
  return (
    <div>
      <div style={{ display: "flex", justifyContent: "center" }}>
        <Link to="/menu" className="bigRedButton">
          Order Online
        </Link>
      </div>
    </div>
  );
}
